import { DATE_FORMAT } from 'constants/general';
import dayjs from 'dayjs';

/** Date and time, on the reader's clock, in the format the table shows a date in. */
const DATASOURCE_EXECUTED_AT_FORMAT = `${DATE_FORMAT} HH:mm`;

/** When a datasource's rows were made, as the "data as of" note shows it. The raw value when it is not a date. */
const formatDatasourceExecutedAt = (executedAt: string): string => {
  const date = dayjs(executedAt);

  return date.isValid() ? date.format(DATASOURCE_EXECUTED_AT_FORMAT) : executedAt;
};

export default formatDatasourceExecutedAt;
